import { gql, TypedDocumentNode } from "@apollo/client";

import { VcsProviderInSpacesGql } from "./types";

export const VCS_PROVIDERS_IN_SPACE: TypedDocumentNode<
  VcsProviderInSpacesGql,
  { spaceId: string }
> = gql`
  query VcsProvidersInSpace($spaceId: ID!) {
    providersInSpace(id: $spaceId)
    githubIntegration {
      useGitCheckout
    }
    originIntegration {
      useGitCheckout
    }
  }
`;
